export function getMeetingProviderIcon(meetingProvider: string) {
  switch (meetingProvider) {
    case "zoom":
      return "Zoom";
    case "teams":
      return "Teams";
    case "meet":
      return "Cluster meet";
    default:
      return meetingProvider?.charAt(0)?.toUpperCase() + meetingProvider?.slice(1)?.toLowerCase();
  }
}
